export function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}



// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/locale/constructor.js